import React from 'react';
import PropTypes from 'prop-types';

import { RoleAllowBrand } from '../../../auth/roleAware';
import Filters from '../filters/containers/Filters';
import Layout from '../components/Layout';
import ShopFilter from '../filters/ShopFilter';

const SettlementReport = ({
  downloadPdf,
}) => (
  <Layout title="Settlement">
    <div className="c-settlement-report-wrapper">
      <div className="c-report-filters">
        <div className="u-mr0 large-and-up-mr- u-mb">
          <Filters
            disableBarberFilter
            showCsvExport={false}
          >
            <RoleAllowBrand>
              <ShopFilter />
            </RoleAllowBrand>
          </Filters>
        </div>
        <button className="c-btn c-btn--medium u-border-radius-8" onClick={downloadPdf}>
          Export to PDF
        </button>
      </div>
    </div>
  </Layout>
);

SettlementReport.propTypes = {
  downloadPdf: PropTypes.func.isRequired,
};

export default SettlementReport;
